import React, { FC } from "react";
import { useTranslation } from "react-i18next";

import { IWorkOrder } from "@/data/work-orders";
import { Flex, Tab, TabList, TabPanel, TabPanels, Tabs } from "@/eworkitComponents";
import { WorkOrderDetailsSections, WorkOrderHeader } from "@/views/components/WorkOrder";

import { WorkOrderDetailsLifecycle } from "./WorkOrderDetailsLifecycle";

interface IWorkOrderDetailsProps {
  workOrder: IWorkOrder;
  update?: () => void;
}

export const WorkOrderDetails: FC<IWorkOrderDetailsProps> = ({ workOrder, update }) => {
  const { t } = useTranslation("session");

  const externalAttachments = workOrder.tasks?.find(task => task.type === "WO_CONFIRM")?.externalAttachments ?? [];

  return (
    <Flex width={12} direction="column" innerMargin="md" margin={[false, false, "md", false]}>
      <Tabs>
        <WorkOrderHeader resource={workOrder} update={update}>
          <TabList size="lg" innerMargin="xs" padding={["sm", false, false, false]}>
            <Tab>
              <Flex margin={[false, "md"]}>{t("WORK_ORDERS.DETAILS.DETAILS")}</Flex>
            </Tab>
            <Tab>
              <Flex margin={[false, "md"]}>{t("WORK_ORDERS.DETAILS.LIFECYCLE")}</Flex>
            </Tab>
          </TabList>
        </WorkOrderHeader>

        <TabPanels>
          <TabPanel padding={["md", false, false, false]}>
            <WorkOrderDetailsSections workOrder={workOrder} externalAttachments={externalAttachments} />
          </TabPanel>

          <TabPanel padding={["md", false, false, false]}>
            <WorkOrderDetailsLifecycle workOrder={workOrder} />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Flex>
  );
};
